import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { delay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PrintService {

  constructor(private logger: NGXLogger) { }

  print(http: HttpClient, url: string, params: HttpParams | { [param: string]: string | string[] }, headerElement: HTMLElement) {
    const header = { 'Accept': 'text/html' }
    return http.get(url, { headers: header, responseType: 'text', params: params })
      .subscribe(res => {
        this.printInBlank(res, headerElement);
      }, err => {
        this.logger.error(err);
        throw err;
      });
  }

  private printInBlank(html: string, headerElement: HTMLElement) {
    let printArea = document.createElement('div');
    printArea.setAttribute('id', 'container');

    // TODO: decorate layout.
    let title = document.createElement('div');
    title.setAttribute('style', 'text-align: center');
    title.appendChild(headerElement);

    printArea.innerHTML = title.outerHTML;
    printArea.innerHTML += html as string;

    const printProxy = window.open();

    if (printProxy == null) {
      alert("팝업 차단 기능이 설정되어있습니다.\n\n차단 기능을 해제(팝업허용) 한 후 다시 시도 부탁드립니다.");
    }

    printProxy.document.write(printArea.innerHTML);

    //printProxy.document.close();
    //printProxy.focus();

    let focus = false;

    //onload 되기전에 print 하면 바코드 이미지 안뜸
    //printProxy.onload = (event) => {          

    //바코드 이미지 표시를 위한.
    setTimeout(() => {
      printProxy.window.print();
      printProxy.focus();
      focus = true;
    },300);

    let timer = setTimeout(() => { if (focus === true) { printProxy.window.close(); } }, 300);

    delay(1000);

    clearTimeout(timer)


  }
}
